import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import ElementUI from 'element-ui';
import client from './utils/client';
import * as util from './utils/util';
import { version } from '../public/manifest.json';
import { Message, MessageBox } from 'element-ui';
import config from './utils/config.service';
// import * as QNRTC from "pili-rtc-web";
// import VConsole from 'vconsole';
// const vConsole = new VConsole();

import { TimeFilter } from './filters/time.filter';

Vue.prototype.$config = config;
Vue.prototype.$util = util;
Vue.prototype.$client = client;
Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.filter('time', TimeFilter);

// config
//   .setConfig()
//   .then(res => {
//     new Vue({
//       router,
//       render: h => h(App)
//     }).$mount('#app');
//   })
//   .catch(e => {
//     console.log('配置文件加载失败！');
//   });
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

// 更新
let time = 10;

const upload = () => {
  clearInterval(timer);
  let random = Math.random();

  fetch(`/manifest.json?random=${random}`).then(res => {
    res.json().then(data => {
      if (data.version !== version) {
        // if (data.version) {
        MessageBox.confirm(`检测到新版本, 将在10秒后为您重新加载.`, '更新提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            setTimeout(() => {
              document.location.reload(true);
            }, 10000);
          })
          .catch(() => {
            Message.info('您选择取消，将在3分钟再次弹窗更新');
            timer = setInterval(upload, 180000);
          });
        let timer1 = setInterval(() => {
          time--;
          if (time == 0) {
            document.location.reload(true);
            clearInterval(timer1);
          }
        }, 1000);
      } else {
        timer = setInterval(upload, 180000);
      }
    });
  });
};

let timer = setInterval(upload, 60000);
